export default "__VITE_ASSET__CEYVj8Eg__"